// 字体大小
export const FONT_SIZE_LIST = [
  10, 11, 12, 13, 14, 16, 18, 20, 24, 28, 36, 38, 48, 72,
]

// 富文本字体大小
export const RICH_FONT_SIZE_LIST = ['10px', '12px', '16px', '18px', '22px', '32px', '48px']

// 地图可选择的区域范围
export const MAP_CHART_CHOOSE_LIST = [
  {
    value: '100000',
    label: '全国',
    children: [
      {
        value: '330000',
        label: '浙江',
        children: [
          { value: '330100', label: '杭州市' },
          { value: '330200', label: '宁波市' },
          {
            value: '330300',
            label: '温州市',
            children: [
              {
                value: '330381',
                label: '瑞安市',
              },
            ],
          },
          { value: '330400', label: '嘉兴市' },
          { value: '330500', label: '湖州市' },
          { value: '330600', label: '绍兴市' },
          { value: '330700', label: '金华市' },
          { value: '330800', label: '衢州市' },
          { value: '330900', label: '舟山市' },
          { value: '331000', label: '台州市' },
          { value: '331100', label: '丽水市' },
        ],
      },
      {
        value: '130000',
        label: '河北省',
        children: [
          { value: '130100', label: '石家庄市' },
          { value: '130200', label: '唐山市' },
          { value: '130300', label: '秦皇岛市' },
          { value: '130400', label: '邯郸市' },
          { value: '130500', label: '邢台市' },
          { value: '130600', label: '保定市' },
          { value: '130700', label: '张家口市' },
          { value: '130800', label: '承德市' },
          { value: '130900', label: '沧州市' },
          { value: '131000', label: '廊坊市' },
          { value: '131100', label: '衡水市' },
        ],
      },
      {
        value: '320000',
        label: '江苏省',
        children: [
          { value: '320100', label: '南京市' },
          { value: '320200', label: '无锡市' },
          { value: '320300', label: '徐州市' },
          { value: '320400', label: '常州市' },
          { value: '320500', label: '苏州市' },
          { value: '320600', label: '南通市' },
          { value: '320700', label: '连云港市' },
          { value: '320800', label: '淮安市' },
          { value: '320900', label: '盐城市' },
          { value: '321000', label: '扬州市' },
          { value: '321100', label: '镇江市' },
          { value: '321200', label: '泰州市' },
          { value: '321300', label: '宿迁市' },
        ],
      },
      {
        value: '350000',
        label: '福建省',
        children: [
          { value: '350100', label: '福州市' },
          { value: '350200', label: '厦门市' },
          { value: '350300', label: '莆田市' },
          { value: '350400', label: '三明市' },
          {
            value: '350500',
            label: '泉州市',
            children: [
              {
                value: '350581',
                label: '石狮市',
              },
            ],
          },
          { value: '350600', label: '漳州市' },
          { value: '350700', label: '南平市' },
          { value: '350800', label: '龙岩市' },
          { value: '350900', label: '宁德市' },
        ],
      },
      {
        value: '370000',
        label: '山东省',
        children: [
          { value: '370100', label: '济南市' },
          { value: '370200', label: '青岛市' },
          { value: '370300', label: '淄博市' },
          { value: '370400', label: '枣庄市' },
          { value: '370500', label: '东营市' },
          { value: '370600', label: '烟台市' },
          { value: '370700', label: '潍坊市' },
          { value: '370800', label: '济宁市' },
          { value: '370900', label: '泰安市' },
          { value: '371000', label: '威海市' },
          { value: '371100', label: '日照市' },
          { value: '371300', label: '临沂市' },
          { value: '371400', label: '德州市' },
          { value: '371500', label: '聊城市' },
          { value: '371600', label: '滨州市' },
          { value: '371700', label: '菏泽市' },
        ],
      },
      {
        value: '530000',
        label: '云南省',
        children: [
          { value: '530100', label: '昆明市' },
          { value: '530300', label: '曲靖市' },
          { value: '530400', label: '玉溪市' },
          { value: '530500', label: '保山市' },
          { value: '530600', label: '昭通市' },
          { value: '530700', label: '丽江市' },
          { value: '530800', label: '普洱市' },
          { value: '530900', label: '临沧市' },
          { value: '532300', label: '楚雄彝族自治州' },
          { value: '532500', label: '红河哈尼族彝族自治州' },
          { value: '532600', label: '文山壮族苗族自治州' },
          { value: '532800', label: '西双版纳傣族自治州' },
          { value: '532900', label: '大理白族自治州' },
          { value: '533100', label: '德宏傣族景颇族自治州' },
          { value: '533300', label: '怒江傈僳族自治' },
          { value: '533400', label: '迪庆藏族自治州' },
        ],
      },
    ],
  },

]

// 默认提供的空大屏配置
export const EMPTY_SCREEN_TEMPLATE = {
  // 尺寸
  panelProportion: '16:9',
  panelWidth: 1920,
  panelHeight: 1080,
  // 大屏名称
  panelName: '',
  // 配色
  chartColors: 'default', // 全局组件配色
  // 背景颜色  注意回填
  backgroundType: 1, // color 1 || template 2
  background: '#071228', // 背景颜色 or 模版图片链接
  // 交互
  jumpPanelId: '', // 是否自动跳转，记录跳转大屏id
  jumpDelaySecond: undefined, // 延迟多少秒跳转另外一个大屏

  // 大屏内包含的组件
  chartViews: [],

  // 空模版的快照
  panelThumbnail: 'https://oss.qlinyun.com/dev/picture/tYZM3FKbzFmYTamAeh25GdsJsymW4AEm.png',
}

//  大屏背景模板
export const BACKGROUND_TEMPLATE_LIST = [
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background1.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background2.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background3.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background4.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background5.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background6.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background7.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background8.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background9.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background10.png',

]

//  组件边框模板
export const BORDER_TEMPLATE_LIST = [
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border1.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border2.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border3.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border4.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border5.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border6.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border7.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border8.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border9.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border10.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border11.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border12.png',
  'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border13.png',

]
